<template>
  <li
    v-for="item in secondaryMenu.menuItems"
    :key="item.id"
  >
    <a
      :href="isExternalUrl(item.slug) ? item.slug : `/${item.slug}`"
      :target="isExternalUrl(item.slug) ? '_blank' : '_self'"
      class="hover:text-gray-800 text-gray-500 text-base font-light w-full flex p-4"
    >
      {{ item.label }}
    </a>
  </li>
</template>
<script setup>

defineProps({
  secondaryMenu: {
    type: Object,
    required: true,
  },
});

const isExternalUrl = (slug) => slug && slug.startsWith('http');

</script>
